import React, { type ReactNode } from 'react';
import { injectIntl, FormattedMessage, type WrappedComponentProps } from 'react-intl-next';
import EmptyState from '@atlaskit/empty-state';
import messages from './messages';
import confluenceActivatingEmptyStateIcon from '../icons/gears.svg';
import mountTrackerFactory from '../../../common/analytics/mount-tracker-factory';
import ContactSupport from '../../../ui/project-pages-improvement/common/contact-support';

export interface OwnProps {}

interface Props extends OwnProps, WrappedComponentProps {}

const MountTracker = mountTrackerFactory('confluenceActivatingEmptyState');
const ConfluenceActivating = ({ intl: { formatMessage } }: Props) => {
	return (
		<div>
			<EmptyState
				size="wide"
				imageUrl={confluenceActivatingEmptyStateIcon}
				maxImageWidth={82}
				header={formatMessage(messages.heading)}
				description={
					<FormattedMessage
						{...messages.description}
						values={{
							link: (chunks: ReactNode) => <ContactSupport label={chunks} />,
						}}
					/>
				}
			/>
			<MountTracker />
		</div>
	);
};

export default injectIntl(ConfluenceActivating);
